/**
 * 新增 修改公用
 */
import popUpEmploye from './view/popUpEmploye.html'
import utils from 'utils'

class parameterConfigurationEditCtrl {
    constructor($scope, httpRequest, $state, $stateParams, formvalidateApi, $uibModal, $timeout, logger, buyerChecker) {
        function reset() {
            $scope.edit = {
                companyName: '', // 名称
                taxNo: '', // 纳税人识别号
                taxBelong: '', // 主管税局所在省市
                pwd: '', // 个税平台登陆密码
                applyType: '2', //申报状态 默认
                employeeNumber: '', // 纳税人类型
                employeeName: '', // 办税员姓名
                logonName: '', //平台登录名称
                shareDir: '', // 办税文件共享路径
                shareUser: '', // 共享文件夹账号
                sharePwd: '', // 共享文件夹密码
                status: 1, //启用
                rpaGroup: '',
                departmentNo: '', //事业部
                regionName: '', //所属大区
                cityName: '', //管理城市
            }
            $scope.params = {
                pageSize: 2000,
                pageNum: 1,
                param: {
                    isRoleOwner: '1', // 拥有本机构角色
                    orgIdList: [JSON.parse(localStorage.user_info).org.orgId], // 所属机构
                },
            }
        }
        function init() {
            reset()
            // 获取所有主管税局信息
            httpRequest.get_getAllTaxBureau(localStorage.getItem('id_token')).then((res) => {
                $scope.ProvinceList = res.data.value
            })
            // 字典
            const typecodeArrStr = ['gs_applyType']
            $scope.dictionary = {}
            httpRequest.get_dictByTypeArr(typecodeArrStr).then((res) => {
                $scope.dictData = $.extend($scope.dictionary, res.data.value)
            })
            // 获取所有用户信息
            httpRequest.post_usersInfo($scope.params).then((res) => {
                $scope.allUserInfo = res.data.value.list
            })
            // 编辑传过来的id
            const { id } = $stateParams
            if (id) {
                $scope.isEdit = true
                httpRequest.get_getGsConfigById(id).then((res) => {
                    $scope.edit = res.data.value
                    $scope.edit.taxBelong = $scope.edit.province
                    // select2控件id和title必要字段 设置默认值
                    $scope.edit.title = $scope.edit.companyName
                    $scope.editDefaulf = $scope.edit
                    $scope.edit.applyType = String(res.data.value.applyType)
                })
            }
        }
        init()
        // 选择纳税人带出相关信息
        $scope.selectTax = function (item) {
            if (!item) {
                $scope.edit.taxNo = ''
                $scope.edit.taxBelong = ''
                $scope.edit.logonName = ''
                $scope.edit.companyName = ''
                $scope.edit.departmentNo = ''
                $scope.edit.regionName = ''
                $scope.edit.cityName = ''
                return
            }
            $scope.edit.taxNo = item.taxNo
            $scope.edit.taxBelong = item.taxBelong
            $scope.edit.logonName = item.taxNo
            $scope.edit.companyName = item.companyName
            $scope.edit.departmentNo = item.departmentNo
            $scope.edit.regionName = item.regionName
            $scope.edit.cityName = item.cityName
        }
        //只能输入0和正整数
        function isRuledNumber(argument) {
            const reg = /^\+?(0|[1-9][0-9]*)$/
            return reg.test(argument)
        }
        // 校验
        $scope.validateRules = {
            taxNo: [
                {
                    erromsg: '必填项',
                    condition(value) {
                        // 规则
                        // true 标示显示 errmsg  false 标示验证通过
                        return !value
                    },
                },
            ],
            companyName: [
                {
                    erromsg: '必填项',
                    condition(value) {
                        // 规则
                        // true 标示显示 errmsg  false 标示验证通过
                        return !value
                    },
                },
            ],
            employeeNumber: [
                {
                    erromsg: '办税员工号必填，请检查。',
                    condition(value) {
                        // 规则
                        // true 标示显示 errmsg  false 标示验证通过
                        return !value
                    },
                },
            ],
            employeeName: [
                {
                    erromsg: '必填项',
                    condition(value) {
                        // 规则
                        // true 标示显示 errmsg  false 标示验证通过
                        return !value
                    },
                },
            ],
            pwd: [
                {
                    erromsg: '个税平台登录密码变量必填，请检查。',
                    condition(value) {
                        return !value
                    },
                },
            ],
            shareIp: [
                {
                    erromsg: '办税员电脑IP必填，请检查。',
                    condition(value) {
                        return !value
                    },
                },
            ],
            shareDir: [
                {
                    erromsg: '办税文件路径必填，请检查。',
                    condition(value) {
                        return !value
                    },
                },
            ],
            rpaGroup: [
                {
                    erromsg: '校验是否整数',
                    condition(value) {
                        return !isRuledNumber(value)
                    },
                },
            ],
        }
        // 办税员工号弹窗
        $scope.popUpEmploye = function () {
            $uibModal
                .open({
                    template: popUpEmploye,
                    controller: 'popUpEmployeCtrl',
                    backdrop: 'static',
                    openedClass: 'mod-modal-modaldetails mod-modal mod-modal-hg',
                    resolve: {
                        modalParams() {
                            return {
                                info: $scope.allUserInfo,
                                type: 'selectFollower',
                            }
                        },
                    },
                })
                .result.then((res) => {
                    getTextByJs(res)
                })
            //拼接字符串
            function getTextByJs(arr) {
                let employeeNumber = ''
                let employeeName = ''
                for (var i = 0; i < arr.length; i++) {
                    employeeNumber += arr[i].userName + ';'
                    employeeName += arr[i].realName + ';'
                }
                //去掉最后一个分号(如果不需要去掉，就不用写)
                if (employeeNumber.length > 0) {
                    employeeNumber = employeeNumber.substr(0, employeeNumber.length - 1)
                }
                if (employeeName.length > 0) {
                    employeeName = employeeName.substr(0, employeeName.length - 1)
                }
                $scope.edit.employeeNumber = employeeNumber
                $scope.edit.employeeName = employeeName
            }
        }
        //选择框默认隐藏
        $scope.isHide = true
        // 办税员工号查询
        $scope.selectSearchNumber = function () {
            $scope.isHide = false
            $scope.shortObj = $scope.allUserInfo
            if (!$scope.edit.employeeNumber) {
                $scope.isHide = true
                $scope.edit.employeeName = ''
                return
            }
            console.log($scope.edit.employeeNumber)
            let searchList = []
            angular.forEach($scope.shortObj, function (item, index, array) {
                if (item.userName.indexOf($scope.edit.employeeNumber) > -1) {
                    searchList.push(item)
                }
            })
            if (searchList.length === 0) {
                $scope.isHide = true
                $scope.edit.employeeName = ''
            }
            $scope.shortObj = searchList
        }
        // 下拉框选择
        $scope.choose = function (val) {
            $scope.isHide = true //下拉框隐藏
            $scope.edit.employeeNumber = val[0] //文本框中的值
            angular.forEach($scope.allUserInfo, function (item, index, array) {
                if (item.userName == $scope.edit.employeeNumber) {
                    $scope.edit.employeeName = item.realName
                }
            })
        }
        // 下拉框显示隐藏
        $scope.isShow = function (val) {
            if (val == 0) {
                if (!$scope.edit.companyName || $scope.shortObjName.length == 0) return
                $scope.hide = !$scope.hide
            } else if (val == 3) {
                $scope.changeKeyValue($scope.edit.companyName)
                // 搜索的效果
                $scope.hide = true
                $timeout(() => {
                    $scope.hide = false
                }, 500)
            } else {
                if (!$scope.edit.employeeNumber || $scope.shortObj.length == 0) return
                $scope.isHide = !$scope.isHide
            }
        }
        const submitHandler = {
            add() {
                //判断名称是否带出税号
                if ($scope.edit.taxNo == '') {
                    logger.logError('纳税人识别号不能为空')
                    return
                } else if ($scope.edit.taxBelong == '') {
                    logger.logError('所属税局不能为空')
                    return
                }
                httpRequest.post_getRpaGsConfigInsert(JSON.stringify($scope.edit)).then((res) => {
                    $scope.encodeURIComponent()
                    logger.logSuccess('参数配置新增成功')
                    $state.go('declaration.personalIncomeTax.parameterConfiguration.list')
                })
            },
            edit() {
                httpRequest.post_getRpaGsConfigEdit($scope.edit).then((res) => {
                    if (res.data.msgCode == 12100) {
                        return
                    }
                    $scope.encodeURIComponent()
                    logger.logSuccess('参数配置修改成功')
                    $state.go('declaration.personalIncomeTax.parameterConfiguration.list')
                })
            },
        }
        // 斜杠编码
        $scope.encodeURIComponent = function () {
            let shareDirStr = $scope.edit.shareDir
            // 判读是否写斜杠 或者只写一个 补全
            if (shareDirStr.charAt(0) !== '\\') {
                shareDirStr = '\\\\' + shareDirStr
            } else if (shareDirStr.charAt(0) == '\\' && shareDirStr.charAt(1) !== '\\') {
                shareDirStr = '\\' + shareDirStr
            }
            //转义替换;
            let encode = shareDirStr.replace(/\\/g, encodeURIComponent('\\'))
            $scope.edit.shareDir = encode
        }
        // 修改 新增并继续
        $scope.submit = function (method) {
            const mark = formvalidateApi.run()
            if (!mark) {
                return
            }
            submitHandler[method]()
        }
        $scope.cancle = function () {
            $state.go('declaration.personalIncomeTax.parameterConfiguration.list')
        }
    }
}
parameterConfigurationEditCtrl.$inject = ['$scope', 'httpRequest', '$state', '$stateParams', 'formvalidateApi', '$uibModal', '$timeout', 'logger', 'buyerChecker']
export default parameterConfigurationEditCtrl



// WEBPACK FOOTER //
// ./src/app/declaration/personalIncomeTax/parameterConfiguration/parameterConfigurationEditCtrl.js